










import Base from "@/controllers/base.ts";
import { Component } from "vue-property-decorator";
import CTabs from "./cTabs.vue";
import MyService from "./cService/myindex.vue";
import CService from "./cService/index.vue";
import Tools from "./cToolsDoc/tools.vue";
import Docs from "./cToolsDoc/docs.vue";

@Component({
  name: "Zhfw",
  components: {
    CTabs,
    MyService,
    CService,
    Tools,
    Docs,
  }
})
export default class MyApp extends Base {
  private tabIndex = 0;

  private created() {
    this.tabsClick();
  }
  private tabsClick(e?: any) {
    if (e) {
      this.tabIndex = e.activeIndex;
    }
  }  
}
